export const BRAND_MESSAGING = {
  coreIdeas: {
    blocker: "what may be getting in the way",
    nextStep: "what your voice needs next",
    guidance: "calm, clear guidance",
    supportPath: "the right support path",
    outcome: "a more natural, confident, expressive voice",
    struggle: "less unnecessary struggle",
  },
  offers: {
    evaluation: {
      label: "Singing Evaluation",
      summary: "the clearest first step when you want to understand what your voice needs next",
    },
    videoFeedback: {
      label: "Video Feedback",
      summary: "a low-pressure support path for clear correction on real clips",
    },
    coaching: {
      label: "1:1 support",
      summary: "deeper guided work when you want live correction and steady momentum",
    },
    confidenceLab: {
      label: "Confidence Lab",
      summary: "weekly live support for calmer, more consistent practice",
    },
    packages: {
      label: "packages",
      summary: "guided support paths for singers who want more structure",
    },
    voiceClarityGuide: {
      label: "voice clarity guide",
      summary: "a calmer way to understand what may be getting in the way before choosing support",
    },
  },
  preferences: {
    favour: [
      "what may be getting in the way",
      "what your voice needs next",
      "calm, clear guidance",
      "the right support path",
      "less unnecessary struggle",
      "more natural, confident, expressive singing",
    ],
    avoid: [
      "support layer",
      "support format",
      "guess between offers",
      "harder effort",
    ],
  },
} as const;

export type BrandMessaging = typeof BRAND_MESSAGING;
